export default "__VITE_ASSET__127390d8__"